"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_PACKAGE_TRANSFER_MAX_PARTS = exports.APP_PACKAGE_CONTAINER_MAX_BYTES = exports.APP_PACKAGE_MAX_ENTRIES = exports.APP_PACKAGE_MAX_BYTES = exports.APP_PACKAGE_SEED_MAX_BYTES = exports.APP_PACKAGE_SEED_BLOCK_BYTES = exports.APP_PACKAGE_LIMITS = void 0;
exports.createAppPackageLimits = createAppPackageLimits;
exports.planAppPackageTransfer = planAppPackageTransfer;
const database_identity_1 = require("@streamlain/database-identity");
const app_base_contract_1 = require("./app-base-contract");
/** streamkit.json, app.json, schemas.json, seed-data.json, manifest.json. */
const APP_PACKAGE_METADATA_ENTRIES = 5;
/** Derive package overhead and upload parts from the same transport budgets. */
function createAppPackageLimits({ seedBlockBytes, seedMaxBytes, artifactMaxBytes = app_base_contract_1.APP_BASE_BUDGETS.maxTotalBytes +
    app_base_contract_1.APP_BASE_BUDGETS.maxManifestBytes, }) {
    // A block is flushed only when the next row does not fit. Neighbouring
    // blocks together exceed one block size; every source may end partially.
    const seedMaxBlocks = 2 * Math.ceil(seedMaxBytes / seedBlockBytes) +
        app_base_contract_1.APP_BASE_BUDGETS.maxDataSources;
    const maxEntries = app_base_contract_1.APP_BASE_BUDGETS.maxFiles + APP_PACKAGE_METADATA_ENTRIES + seedMaxBlocks;
    // The artifact budget also holds inline seed-data.json; blocks are separate.
    const maxBytes = artifactMaxBytes + seedBlockBytes;
    // ZIP overhead follows the entry/path bounds and is not charged to rows.
    const containerMaxBytes = maxBytes + seedMaxBytes + maxEntries * 1024;
    return Object.freeze({
        seedBlockBytes,
        seedMaxBytes,
        maxBytes,
        maxEntries,
        containerMaxBytes,
        transferMaxParts: Math.ceil(containerMaxBytes / seedBlockBytes),
    });
}
/** Production defaults: per-database imports still enforce their own row/cell limits. */
exports.APP_PACKAGE_LIMITS = createAppPackageLimits({
    seedBlockBytes: database_identity_1.DATABASE_LARGE_DATA_POLICY.import.inlineEstimatedByteHardLimit,
    seedMaxBytes: 25 * 1024 * 1024,
});
/** Existing exports are views of the one production limits object. */
exports.APP_PACKAGE_SEED_BLOCK_BYTES = exports.APP_PACKAGE_LIMITS.seedBlockBytes;
exports.APP_PACKAGE_SEED_MAX_BYTES = exports.APP_PACKAGE_LIMITS.seedMaxBytes;
exports.APP_PACKAGE_MAX_BYTES = exports.APP_PACKAGE_LIMITS.maxBytes;
exports.APP_PACKAGE_MAX_ENTRIES = exports.APP_PACKAGE_LIMITS.maxEntries;
exports.APP_PACKAGE_CONTAINER_MAX_BYTES = exports.APP_PACKAGE_LIMITS.containerMaxBytes;
exports.APP_PACKAGE_TRANSFER_MAX_PARTS = exports.APP_PACKAGE_LIMITS.transferMaxParts;
/**
 * How a client sends an App package of `size` bytes. Returns null for an
 * empty package and for one above the import staging limit.
 */
function planAppPackageTransfer(size, limits = exports.APP_PACKAGE_LIMITS) {
    if (!Number.isSafeInteger(size) ||
        size <= 0 ||
        size > limits.containerMaxBytes)
        return null;
    if (size <= limits.maxBytes)
        return { route: 'prepare', blocks: [] };
    const blocks = [];
    for (let start = 0; start < size; start += limits.seedBlockBytes) {
        blocks.push([start, Math.min(size, start + limits.seedBlockBytes)]);
    }
    return { route: 'prepare-blocks', blocks };
}
